<template>
  <div>

    <v-container fluid class="pa-md-8 pt-md-2">
      <v-row>
        <v-col cols="12" md="6">
          <v-card color="primary" dark @click="openFormCreateDialog(null)" min-height="130" class="template-block">
            <v-card-title>
              <v-icon left>mdi-text-box-outline</v-icon> Leeg formulier
            </v-card-title>
            <v-card-subtitle>Maak een nieuw leeg formulier.</v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
        <v-row>
          <v-col class="pb-0">
            <h4>Templates</h4>
          </v-col>
        </v-row>
      <v-row>

        <template v-if="isLoading">
          <v-col cols="12" md="6" v-for="n in 10" :key="n">
            <v-skeleton-loader type="article"></v-skeleton-loader>
          </v-col>
        </template>

        <v-col cols="6" v-for="form_template in form_templates" :key="form_template._id">
          <v-card @click="openPreviewDialog(form_template)"  min-height="130" class="template-block">
            <v-card-title>
              <v-icon left>mdi-text-box-outline</v-icon> {{ form_template.form_name }}
            </v-card-title>
            <v-card-subtitle v-if="form_template.form_description">
              <div style="white-space: pre-wrap;">{{ form_template.form_description }}</div>
            </v-card-subtitle>
            <v-card-actions>
              <v-btn depressed color="primary" @click.stop="openFormCreateDialog(form_template)">Gebruik template</v-btn>
              <v-btn outlined color="secondary" @click.stop="openPreviewDialog(form_template)">Voorbeeld</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>

      </v-row>
    </v-container>

    <v-dialog v-model="createFormDialog" max-width="600" persistent scrollable>
        <form-create
            :folder_id="folder_id"
            :duplicate_form="selected_form"
            @formCreated="closeFormCreateDialog"
            @formCreateCancelled="closeFormCreateDialog"
        />
    </v-dialog>

    <v-dialog v-model="previewDialog" max-width="900" scrollable>
      <v-card>
        <v-card-title>
          Voorbeeld: {{ selected_form ? selected_form.form_name : '' }}
        </v-card-title>
        <v-card-text class="background-color">

          <form-preview class="py-4" v-if="selected_form" :my-form="selected_form"></form-preview>

        </v-card-text>
        <v-card-actions>
          <v-btn outlined color="secondary" @click="previewDialog = false">Sluit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import userHelpers from "@/mixins/userHelpers";
import axios from "@/plugins/axios";
import {mapGetters} from "vuex";
import FormCreate from "@/views/forms/FormCreate.vue";
import eformConditionals from "@/mixins/eformConditionals";
import formPreview from "@/views/forms/FormPreview.vue";

export default {
  name: "FormCreateWizard",
  props: {
    folder_id: {
      type: String,
      default: null
    }
  },
  components: {
    FormCreate,
    formPreview,
  },
  mixins: [
    userHelpers,
    eformConditionals,
  ],
  data () {
    return {
      form_templates: [],
      selected_form: null, // The selected template to duplicate. Set to null for blank form.
      createFormDialog: false,
      previewDialog: false,
      isLoading: true,
    }
  },
  computed: {
    ...mapGetters({CurrentClient: "CurrentClient"}),
  },
  async mounted () {
    // Fetch templates
    await this.getTemplates();
  },
  methods: {
    // Send the form to the API endpoint
    async getTemplates() {
      // Load templates from API
      this.isLoading = true;
      // Load templates with axios
      try {
        let response = await axios.get('api/forms/templates/'+this.CurrentClient);
        this.form_templates = response.data;

      } catch (error) {
        console.log(error);
      }

      this.isLoading = false;
    },
    openFormCreateDialog(duplicate_form = null) {
      this.selected_form = duplicate_form;
      this.createFormDialog = true;
    },
    closeFormCreateDialog() {
      this.createFormDialog = false;
      this.selected_form = null;
    },
    openPreviewDialog(form_template) {
      this.selected_form = form_template;
      this.previewDialog = true;
    },
  }
}
</script>

<style scoped>

</style>